export const TRANSLATIONS_EN = {
  equivalencyRequestPath: 'equivalency', // [pertenecen a routing]
  equivalencyConsultPath: 'simulador', // [pertenecen a routing]
  equivalencySearchPath: 'search-equivalency', // [pertenecen a routing]
  institutionsTitle: 'Institutions',
  equivalenciesTitle: 'Equivalencies',
  filterMessageActivity: 'Filter the activities/subjects by name',
  cancelLabel: 'Cancel',
  searchLabel: 'Search',
  backLabel: 'Back',
  helpLabel: 'Help',
  emptyListMessage: 'No item has been found',
  equivalencyRequestTitle: 'Upload equivalency request',
  equivalencyExploreTitle: 'Simulate equivalences',
  equivalencySearchTitle: 'Tracking requests',
  equivalencyRequestListSimulate: 'Available equivalencies',
  equivalencyConsultEmptySimulation: 'No equivalencies were found for the selected Career/Syllabus',
  uploadApplicationTitle: 'How to upload an application?',
  cleanLabel: 'Clear',
  institutionIdNeeded: 'To search for careers/syllabuses you first need to select the institution where they are held',
  source: 'Source',
  target: 'Target',
  sourceActivity: 'Submitted Subject/Activity',
  targetActivity: 'Granted Subject/Activity',
  state: 'Status',
  institutionsSource: 'Select the university/institution you are coming from',
  planSource: 'Which Career/Syllabus holds the subjects or activities you have passed?',
  planTarget: 'For which target Career/Syllabus are you requesting these equivalencies are granted?',
  unauthorizedAccessTitle: 'You are not authorized to access this page',
  unauthorizedAccessDescription: 'Apparently, you do not have permission to access this page. \n\n Please check your credentials and try again or contact us at 0800-Siglo21.',
  pageNotFoundTitle: 'Sorry, page not found',
  pageNotFoundDescription: 'The page you requested does not exist or it is not available. \n\n Please, try going back to the previous page.',
  serverErrorTitle: 'Server Error',
  serverErrorDesc: 'We are sorry, an error has occurred and your request could not be completed. \n\n Please, wait a few minutes and try reloading the page.',
  calification: 'Grade',
  finishDate: 'Course passed date',
  book: 'Book',
  folder: 'Page',
  loginLabel: 'Log in',
  reloadLabel: 'Reload',
  firstName: 'Name',
  lastName: 'Surname',
  phone: 'Phone',
  email: 'Email',
  documentType: 'Identification type',
  documentNumber: 'Identification number',
  yourPersonalData: 'In order to continue, please enter your personal data',
  completeAllSubjectInfoLabel: 'To give course to your request, proceed to the next step to provide the requested information on your submitted subjects/activities',
  selectoriginActivitiesLabel: 'Select the subjects/activities you have passed',
  equivalencyRequestIntro: 'We will guide you through the process so that you can complete your equivalency request. Make sure you have close-by the grade, book and page of the subjects/activities that you have passed',
  consultEquivalencyIntro: 'Select the institution you are coming from together with the Career/Syllabus you have taken so that we can show you the careers/syllabuses in Siglo 21 that can hold equivalencies.',
  enrichEquivalencyinfo: 'To continue with your request, upload the requested information for each selected subject or activity',
  moreInfoOriginActivities: 'We will need more information on the subjects or activities that you passed',
  destinyTableInfo: 'These are the equivalencies that are available for you to request based on the subjects/activities you have selected',
  originTableInfo: 'Select the row that contains the subjects or activities that you have passed in your previous career',
  equivalenceManager: 'Equivalency Request Portal',
  noOptionsTextInstitutions: 'Start typing to search for an institution ...',
  noOptionsTextSyllabuses: 'Start typing to search for a syllabus ...',
  showEntireTable: 'Show all items',
  encountered: 'There have been found',
  compatiblePlans: 'compatible subjects/activities',
  continueRequest: 'Continue with the request',
  myPersonalData: 'My personal data',
  confirm: 'Confirm',
  stepOneName: 'Step 1',
  stepTwoName: 'Step 2',
  stepThreeName: 'Step 3',
  stepFourName: 'Step 4',
  stepFiveName: 'Step 5',
  searchEquivalencies: 'Find the status of your equivalencies',
  trackingNumber: 'Tracking number',
  grantedActivityMesage: 'This subject/activity has been accredited as an equivalency',
  pendingActivityMesage: 'This subject/activity will be validated against your academic transcripts',
  proposalActivityMesage: 'This equivalency is pending approval',
  warningActivityMesage: 'This subject/activity will not grant you an equivalency, you must add it manually.',
  warningActivityMesageWithUseValid: 'This subject will not grant equivalencies.',
  uploadApplication: 'Upload a request here',
  noEquivalencyinfo: 'We do not have any identified equivalency for the subjects/activities you have selected',
  makeRequest: 'Make a new request',
  noEquivalencyRequestsWhereFound: 'No equivalency requests were found',
  pendingReview: 'Pending review',
  lastUpdateDate: 'Review date',
  rejected: 'Rejected',
  approved: 'Completed',
  pending: 'Pending',
  equivalency: 'Equivalency',
  sourceInstitution: 'Source Institution',
  stargetInstitution: 'Target Institution',
  targetSyllabus: 'Target Career/Syllabus',
  sourceSyllabus: 'Source Career/Syllabus',
  approvedEquivalencyRequest: 'Your equivalency request has been completed',
  rejectedEquivalencyRequest: 'Your equivalency request has been rejected',
  reviewEquivalencyRequest: 'Your request for equivalence has a review request and is being analyzed.',
  pendingEquivalencyRequest: 'The equivalency request is pending approval/rejection',
  emptyEquivalenciesEror: 'There is a problem with your equivalencies. Please contact Support and provide them your tracking number',
  invalidEmail: 'Please enter a valid email address',
  InvalidIdentification: 'Please enter a valid identification number',
  invalidName: 'Please enter a valid name',
  invalidLastName: 'Please enter a valid last name',
  invalidPhone: 'Please enter a 10-digit phone number without leading 0.',
  requiredFields: 'required fields',
  successMessageOnRequestSended: 'Your equivalency request has been submitted successfully!',
  equivalencyRequestLinkLabel: 'Click on this link to check the Status of your request or save this link to view it later',
  thisIsYourTrackingCode: 'This is your tracking code:',
  errorConsultingData: 'There has been an error while reading the data',
  requestEquivalencies: 'Request equivalencies',
  findCandidateSyllabus: 'We found the following careers/syllabuses to request equivalencies:',
  targetSyllabusIsNeeded: 'You must select a source Career/Syllabus to search for a target Career/Syllabus',
  requiredField: 'Required field',
  requiredFieldIsNotEnough: 'Make sure the image is of your ID and is legible',
  emptyCandidateSyltivitylabus: 'For the institution and Career/Syllabus you selected, we do not have careers/syllabuses available to check for equivalencies.',
  messageLinkFoundSyllabus: 'If you cannot find your Career/Syllabus, please follow this link',
  addActivityWhenNotExist: 'Add Subject/Activity',
  addActivity: 'Agregar Subject/Activity',
  characterMustBeBetween: 'The number of characters must be between',
  and: 'and',
  typeNewActivityLabel: 'Add the name of the Subject/Activity you need',
  activitiesSubmitted: 'Subjects/Activities submitted',
  Observation: 'Note: ',
  confirmSaveChanges: 'Do you wish to save changes?',
  successMessageOnStudentSaved: 'Your data has been successfully saved.',
  enterNotExistsSyllabus: 'We do not have this Career/Syllabus loaded in our system, but you can still continue with your equivalencies request',
  enterNotExistsInstitution: 'We do not have this institution loaded in our system, but you can still continue with your equivalencies request',
  country: 'Country',
  province: 'Province/State',
  city: 'City',
  Add: 'Add',
  addActivityThatNotExist: 'Add the name of the subject or activity yourself if it is not listed here',
  activityAlreadyExists: 'The subject or activity you are trying to add already exists in the list.',
  emptyEquivalencies: 'There are no equivalencies for the subjects/activities you have entered',
  titleFinalStep: 'Request completed!',
  next: 'Next',
  start: 'Start',
  rememberStudentData: 'Remember: uploading documents is not mandatory to proceed with the next steps, but it will be necessary to successfully complete and submit your application.',
  duFront: 'ID card Front',
  duBack: 'ID card Back',
  duIsMissing: 'ID is missing',
  academicReport: 'Academic report',
  finish: 'Finish',
  confirmationTitle: 'Request Confirmation',
  confirmationSubtitle: 'Please verify the information before proceeding.',
  fieldLabel: 'Field',
  valueLabel: 'Value',
  nameLabel: 'Full Name',
  emailLabel: 'Email Address',
  originInstitutionLabel: 'Origin Institution',
  originPlanLabel: 'Origin Career/Plan',
  targetCareerLabel: 'Target Career',
  targetInstitutionTitle: 'You will be requesting equivalencies to be credited towards a Career/Syllabus you will be doing at SIGLO 21',
  activitiesApprovalsLabel: 'Select the subjects or activities that you passed, and if you don\'t see one listed, add it',
  equivalencyRequestEmptySimulation: 'No equivalencies have been found for the subjects you studied at{{sourceInstitutionName}} - {{targetSyllabusName}}',
  addOptionAutocomplete: 'Start typing to add an option...',
  noOptionsTextDefault: 'Start typing to initiate search...',
  labelSourceActivitiesTable: 'Select those subjects you have passed. If they are not listed here, you can add them yourself',
  labelStudentRecordActivitiesTable: 'Passed Subjects/Activities',
  requiresProgram: 'Syllabus must be uploaded',
  requiresProgramWarning: 'We need you to upload the syllabus of each Subject/Activity you added manually. (Max {{fileSize}})',
  approvedActivitiesTitle: 'Subjects/Activities you have passed',
  repeatEmail: 'Confirm your email address',
  fieldsNoMatch: 'The fields {{field}} do not match.',
  titleInitialStep: 'Equivalencies',
  titleAcademicHistoryStep: 'Tell us about your previous studies',
  titleTargetSelectionStep: 'Select the Career/Syllabus you are interested in',
  titleSuggestedSyllabousTable: 'Suggested Careers/Syllabuses',
  titleStudentRecordsTable: 'Started careers/syllabuses',
  titleActivitiesSelectionStep: 'Select the subjects you have passed and add manually thouse that are not listed',
  titleStudentDataStep: 'Personal and contact information',
  titleStudentRecordActivitiesStep: 'Complete the academic data on the subjects you passed at the institution you are coming from',
  titleUniversityDocumentsStep: 'Upload official, valid documentation',
  stepsDescription: 'Request your equivalencies in a few, simple steps',
  stepsSubDescriptionOne: 'Remember to have on hand the transcript, the study plan and the programs of the subjects that you have passed at your home university.',
  stepsSubDescriptionTwo: 'In the following ',
  stepsSubDescriptionThree: 'video',
  stepsSubDescriptionFour: ' you can see a tutorial on how to upload an equivalence request.',
  stepOneDescription: 'Complete your personal and contact information',
  stepTwoDescription: 'Select the Career and Syllabus and simulate the request for equivalencies',
  stepThreeDescription: 'Select the approved subjects and complete the corresponding information',
  stepFourDescription: 'Verify and/or add suggestions for equivalencies',
  stepFiveDescription: 'Attach mandatory documentation/records (ID and Official Academic Transcripts)',
  stepsEndTitle: 'AND THAT WILL BE ALL!',
  stepsEndDescription: 'We will proceed with your request once you have taken all the steps in your Equivalency Request and provided us with the required information and official records.',
  sourceInstitutionLabel: 'Select the institution you are coming from',
  sourceInstitutionNotFoundLabel: '(If it is not listed here, you can add it manually)',
  sourceSyllabusLabel: 'Select the career and syllabus that you studied',
  sourceRequiredSyllabusLabel: 'After selecting the career, you must select the approved courses',
  sourceSyllabusNotFoundLabel: '(If they are not listed here, you can add them manually. Do not use acronyms or abbreviations.)',
  targetSyllabusTitle: 'Select your career in SIGLO 21',
  simulateEquivalences: 'Fill out the form to see the equivalencies.',
  equivalencyRequestDisclaimer: '“University Siglo 21 takes as valid academic portions taken at other educational institutions once syllabuses, depth and approach of content have been analyzed. The university will not proceed with those requests that reveal discrepancies between the data entered in this form and the official documents/records that support them."',
  newActivityHelper: '¿Have you not found the Subject/Activity you were looking for? Upload it manually and a Siglo 21 analyst will review your equivalency request once you have completed all the required steps.',
  syllabusFile: 'Course syllabus',
  finalStepInfo: 'We will analyze your request and will contact you if the information entered in this form is valid and the official documents/records support it.',
  selectImage: 'Select an image',
  selectPdf: 'Select a PDF file',
  requestLoading: 'Your request is being processed. Please wait...',
  MOBILE: 'Cellphone No.',
  LANDLINE: 'Landline',
  invalidPhoneAR: 'Enter your phone number with no leading 0’s and the 15 prefix removed (10 digits)',
  phoneType: 'Phone type',
  countryPhoneCode: 'Country phone code',
  weAnalizeYourRequest: 'We will review your request and advise which equivalencies we should be able to grant you.',
  selectApprovedSubjects: 'Select the subjects you have passed.',
  invalidFileType: 'The selected file is in an invalid format.',
  invalidFileSize: 'The selected file size is too large.',
  closeLabel: 'Close',
  acceptLabel: 'Accept',
  saveLabel: 'Save',
  fileProblemMessage: 'There was an error while loading the files. Please try again.',
  requestProblemMessage: 'There was an error while processing your Equivalency Request. Please try again.',
  defaultProblemMessage: 'An unexpected error has occurred. Please try again.',
  sendFile: 'Send',
  du_front: 'DU FRON',
  du_back: 'DU BACK',
  academic_report: 'ACADEMIC REPORT',
  syllabus: 'SYLLABUS',
  maxFileSize: 'Maximum file size allowed: ',
  maximum: 'Maximum',
  validating: 'Validating documentation...',
  allowedType: 'Allowed:',
  successMessageOnFilesRequestSended: 'Your equivalency request has been updated successfully!',
  analyticText: 'You must attach the certificate of tertiary studies or undergraduate degree.',
  analyticTextLine2: 'It should be issued and legalized by the source institution.',
  syllabusText: 'The syllabus should be issued and legalized by the source institution.',
  documentsNote: 'NOTE: If the documentation has a digital signature, you must upload the file as it was issued by the institution, otherwise it will be considered invalid.',
  modalitiesText: 'NOTE: GRADO MTD is corresponding with ED (EDUCACION DISTRIBUIDA) and EDH (EDUCACION DITRIBUIDA HOME) modalities.',
  hereLabel: 'here',
  authSuggestion: 'If you are a student at Siglo 21, log in so that we can provide you with a better experience in the equivalence application process.',
  exploreEquivalencySuggestion: 'To have a look at which courses or subjects may be granted as equivalencies, click ',
  authSuggestionTitle: 'Do you already have a user account with Siglo 21?',
  skipLabel: 'Skip',
  onlyMine: 'Show only my Student Records',
  previousRequestTitle: 'The is at least one request pending',
  previousRequestText1: 'You already have equivalency requests submitted',
  previousRequestText2: 'You already have an equivalency application submitted for the selected destination degree',
  previousRequestTextWithActivities: ' with matching courses',
  previousRequestText3: '. If you want to submit a new request, delete the associated courses to generate a new one.',
  previousRequestText4: '. You can check it out or choose a different destination career.' ,
  previousRequestEndedTitle: 'You have at least one request ended',
  previousRequestPendingText: 'At least one equivalency request identical to the one you want to submit already exists in Pending status.',
  previousRequestEditableText: 'At least one equivalency request identical to the one you want to submit already exists in Pending status, and, for at least one of them, you must update the submitted documentation. To do that, please press Edit.',
  previousRequestEndedText: 'You can request a review of the decision if you go and check the original request.',
  previousRequestAllReviewed: 'At least one equivalency request identical to the one you want to submit already exists in Completed status, and all of them have been reviewed. You can make a new request by pressing the button continue.',
  updateDocumentation: 'Update documentation',
  makeRevision: 'Make a revision',
  editLabel: 'edit',
  editLabelCapitalize: 'Edit',
  viewLabel: 'view',
  actionLabel: 'Action',
  targetSyllabusNameLabel: 'Target syllabus name',
  sourceSyllabusNameLabel: 'Source syllabus name',
  continueLabel: 'Continue',
  continueText: 'Continuar',
  followRequest: 'Follow your request',
  createdDate: 'Created date',
  caseNumberLabel: 'Case number',
  addOptionText: 'Add option',
  subjectNotFoundText: 'Enter the name of the subject you could not find',
  missingDocuments: 'The ID documents are missing',
  activitiesTitle: 'Activities/Subjects',
  equivalencyRequestDisclaimerStudentRecordActivitiesStep: 'NOTE: The approval record must be completed with the overall average, graduation date, book, and page number registered at the bottom of the transcript. If the document does not have this information, complete it with the data from the last approved subject.',
  generalConditions: 'General Conditions',
  conditionsSpelling: 'You must enter the name of the subject of your home degree in capital letters and with accents.',
  termsAndConditions1: 'I hereby declare under oath that all the documentation attached in digital format is a true copy of its original and has been issued by the competent authority of the Institution where I have studied. The falsehood or inaccuracy of any of the information provided may initiate an administrative inquiry and the application of possible disciplinary sanctions.',
  termsAndConditions2: 'Likewise, I acknowledge the current Regulation for Recognition of Studies, which establishes the scope, procedures, and requirements for the recognition of equivalent subjects taken at another institution in order to complete studies in a degree at UES21.',
  termsAndConditions3: 'In this sense, I acknowledge and accept that until Universidad Empresarial Siglo 21 (UES21) issues a decision regarding the requested equivalence, I will be temporarily assigned the status of Conditional Regular at the time of receiving this signed Note. I understand that failure to comply with the deadline to complete the documentation for the procedure will result in my status being changed to Independent in the requested subject(s).',
  termsAndConditions4: 'The deadline for document submission is defined as:',
  termsAndConditions5: ' Until Tuesday of the fifth week of classes inclusive.',
  termsAndConditions6: 'Exceptionally, in those cases that the Recognition of Studies Center considers it necessary, it may request the submission of the documentation in its original form, which must be sent to the Recognition of Studies Center (CRE), located at De los latinos Nº8555 – Bº Los Boulevares – Ciudad de Córdoba – Provincia de Córdoba.',
  lookingMatches: 'Looking for matches ...',
  dateApprovalError: 'Enter a valid date',
  rejectedRequestFailFiles: 'Canceled due to file upload failure',
  labelTargetInstAndSyllabusInstEqual: 'Select the subjects you have passed',
  showFileTooltipText: 'View file',
  updateFileTooltipText: 'Update file',
  fileContainerTitle: 'Documentation',
  fileNotAvailableTitle: 'Documentation not available',
  fileNotAvailableMessage: 'The documentation is no longer available as the maximum time has elapsed after the procedure was completed.',
  invalidDateMessage: 'The date must be greater than {{dateForMessage}} and less than or equal to the current date.',
  termsAndConditions: 'terms and conditions',
  acceptTermsAndConditions: 'I accept the ',
  readAndAcceptTermsAndConditions: 'I have read and accept the ',
  cleanFields: 'Clear fields',
  automaticEquivalenciesInfo: 'NOTE: If after entering a subject you do not see one listed as equivalent, submit your request anyway as the possibility exists that the subject is granted an equivalency.',
  documentationStepCompletedTooltip: 'Documentation step completed because the student has already uploaded the required documentation',
  loadingCompatibleSyllabuses: 'Loading compatible syllabuses...',
  mandatoryDataNeeded: 'You must complete the mandatory fields',
  requestReviewTtile: 'Request for review',
  requestReview: 'Please note that this review request can only be made once.',
  requestReviewInvalid: 'Your review request is being reviewed.',
  requestReviewed: 'Your review request is being reviewed.',
  newReviewRequest: 'See related request here',
  reviewLabel: 'Submit your request',
  tramitNumber: 'Request number',
  finishedEquivalencyRequestTitle: 'Completed',
  approvedEquivalencyRequestState: 'Approved',
  rejectedEquivalencyRequestTitle: 'Rejected',
  pendingEquivalencyRequestTitle: 'Pending',
  inReviewEquivalencyRequestTitle: 'In Review',
  approvedEquivalencyRequestTitle: 'Granted',
  activity: 'Activity',
  aprovedStudentSubjects: 'Subjects/Activities submitted by the student',
  expandAll: 'Expand all rows',
  collapseAll: 'Collapse all rows',
  unknowActivity: 'Unkown Subject/Activity',
  grade: 'Grade',
  approvedDate: 'Subject passed date',
  page: 'Page',
  manageRequestEquivalencies: 'Request equivalencies',
  equivalencyGranted: 'Equivalency Granted',
  code: 'Code',
  requestDetailSourceTitle: 'Equivalency request details',
  proposalDuplicated: 'There is already a proposal with the same data',
  proposalDialogTitle: 'Equivalency proposal',
  proposalSourceActivity: 'Source activity',
  proposalTargetActivity: 'Destination activity',
  minContentTargetSelectionDescripcion: 'You must select the target activity that you think is equivalent to the source activity.',
  minContentDescription: '(You must all the content of the source activity)',
  proposalComments: 'Comments',
  minContent: 'Minimum content',
  addProposal: 'Add equivalency proposal',
  addProposalShort: 'Add proposal',
  cantAddProposal: 'No se pueden agregar sugerencias de equivalencia ya que todas las materias seleccionadas tienen equivalencias otorgadas.',
  cantAddProposalInternal: 'Suggestions cannot be added to an internal equivalence.',
  deleteProposal: 'Delete equivalency proposal',
  associatedSubjects: 'Associated subjects',
  associatedSubjectsDescription: 'We detected that the following subjects already exist in previous applications. You must remove them from your current selection to generate a new application:',
  hideSubjects: 'Hide subjects',
  showSubjects: 'Show subjects',
  statusLabel: "State",
  linkLabel: "Link",
  pendingLabel: "Pending",
  endedLabel: "Ended",
  viewLabelPending: "View request",
  proposalInfo: 'Note: Add manually the equivalency proposal if it is not listed here',
  DocumentFront: 'ID Card front',
  DocumentFrontDescription: 'See front of ID Card',
  DocumentBack: 'ID Card back',
  DocumentBackDescription: 'See back of ID Card',
  requestingFileExistance: 'Checking file existence',
  SyllabusProgram: 'Career Plan',
  ActivityProgram: 'Activity Plan',
  proposalShowComment: 'Show comment',
  proposalTableTitle: 'Equivalency proposals',
  proposalDialogCommentTitle: 'Comment from the applicant',
  fileAlert: 'Re-upload of the corresponding files is required.',
  actions: 'Actions',
  errorequivalencyMesage: 'This equivalnecy will not be granted.',
  verifyInstitution: 'Check that the name of your home institution appears exactly as it appears on your transcript. An error in the uploaded data may cause the application to be rejected and you will have to upload it again.',
  verifySyllabus: 'Verify that the year and/or ministerial resolution you uploaded matches the one that appears in your study plan.',
  infoSuggestedSyllabus: 'The courses shown by default are suggestions from the institution, based on the best percentage of progress with your original plan. You can use the search engine to select other courses and modalities according to your preference.',
  sourceProposalProgramCondition: 'The course program that you must attach must be complete, issued, legalized and paginated by your home institution. If the PDF has a digital signature, do not edit or divide it, since editing it makes it invalid.',
  sourceProposalProgramValidation: 'Verify that the program of your home subject meets the minimum contents of the century subject, otherwise you will lose the subject granted as conditional as well as any correlative subject you are taking.',
  rejectedCommentDialogTitle: 'Rejection Comment',
  minContentDialogTitle: 'Minimum Content',
  rejectedShowComment: 'Show rejected comment',
  minContentShowComment: 'Show minimum content',
  minContentDescripcion: 'There is no minimum content available.',
  minContentHelpText: 'The minimun conten will be shown after the selection of the target activity.',
  caution: 'Caution',
  uncheckActivityDialogMessageOne: 'You are about to uncheck the following subject/activity: ',
  uncheckActivityDialogMessageTwo: 'This action will remove the equivalencies and proposals related to the subject/activity. Are you sure you want to continue?',
  uncheckActivityTooltip: 'Uncheck subject/activity',
  noActivitiesSelected: 'No subjects/activities selected, please select at least one in step 2.',
  dataLoaded: 'Data loaded',
  loadData: 'Load data',
  editData: 'Edit data',
  fileFormatError: 'Incorrect file format',
  proposalNotReachesMinThreshold: 'The proposal does not reach the minimum content threshold',
  proposalReachesMinThreshold: 'The equivalency will be granted, but is pending to be reviewed by the academic department.',
  fileDescription: 'Please check that the name of the home institution and the degree/study plan match exactly what appears in the “study plan” file.',
  sourceHelpDialogTitle: 'Add another institution where you studied',
  sourceHelpDialogMessage: 'You must upload an equivalency request for each institution where you have studied.',
  infotitle: 'Additional information',
  documentationHelpButton: 'How to upload documentation?',
  cantSkipStep: 'First you must complete the required fields of the previous steps.',
  sourceTableTitle: 'Origin subjects/activities',
  proposalsTitle: 'Equivalency proposals',
  confirmationDialogCompleteOriginActivitiesTitle: 'Complete the origin activities',
  confirmationDialogCompleteProposalsTitle: 'Complete the proposals',
  confirmationDialogUserValidTitle: 'There are one or more original courses that do not provide any equivalency. To complete this application, you must remove those courses from the application.',
  confirmationDialogSelectTargetSyllabusTitle: 'Select the target syllabus',
  confirmationDialogCheckTermsAndConditionsTitle: 'Check the terms and conditions',
  confirmationDialogCheckStudyPlanAndAcademicReportTitle: 'Check the study plan and academic report',
  confirmationDialogCheckAcademicReportTitleSuccess: 'Analytics successfully loaded',
  confirmationDialogCheckStudyPlanReportTitleSuccess: 'Curriculum loaded successfully',
  confirmationDialogCompleteDu: 'You must upload the document images correctly.',
  confirmationDialogCompleteDuSucess: 'Document images uploaded successfully',
  messageCoincidenceList: 'Some coincidences found with the entered name are:',
  newSyllabusText: "Don't see your syllabus? Add it here ",
  newInstitutionText: "Don't see your intitution? Add it here ",
  newActivityText: "Don't see your activity? Add it here ",
  here: 'here',
  confirmationRedirectTitle: 'Go to step',
  confirmationDialogExtraConfirmationTitle: 'Check again the information, if you want to edit something, click on the step you want to edit',
  createNewActivity: 'Create new activity',
  nameNewActivity: 'Activity name',
  newActivityErrorMessage: 'There is an activity with the same name in the list, please select that activity from the list.',
  createNewInstitution: 'Create a new institution',
  nameNewInstitution: 'Insitution name',
  newInstitutionErrorMessage: 'There is an institution with the same name in the list, please select that institution from the list.',
  createNewSyllabus: 'Create a new syllabus',
  nameNewSyllabus: 'Syllabus name',
  newSyllabusErrorMessage: 'There is an syllabus with the same name in the list, please select that syllabus from the list.',
  selectModeTitle: 'What equivalence are you going to request',
  internalModeTitle: 'Internal',
  internalModeSubtitle: 'If you have passed subjects in any Siglo degree and you are studying a second degree or are thinking of enrolling in a second degree',
  externalModeTitle: 'External',
  externalModeSubtitle: 'If you come from another university',
  tagModalTextOne: 'Once you complete the admission in',
  tagModalTextTwo: 'we will grant you the equivalencies for the subjects you have passed in',
  tagModalTextThree: 'automatically within a period of',
  tagModalTextFour: 'days. You do not need to upload a procedure.',
  pendingRequestOne: 'We are already managing the equivalences corresponding to the',
  pendingRequestTwo: 'between',
  pendingRequestThree: 'and',
  pendingRequestFour: "You don't need to upload an application. Here:",
  pendingRequestFive: "You'll be able to see the status of the process. We'll notify you by email when it's complete.",
  endedRequestOne: 'You already have the subjects approved corresponding to the',
  endedRequestTwo: 'between',
  endedRequestThree: 'and',
  endedRequestFour: "You don't need to upload an application. Here:",
  endedRequestFive: 'You will be able to see the list of subjects that were assigned to you and the details of the procedure.',
  targetSyllabusSelected: 'Selected career/plan destination',
  ourceSyllabusSelected: 'Selected career/origin plan',
  sourceInstitutionSelected: 'Selected institution',
  sourceDataVerified: 'Verify that the data is correct.',
  NoCoincidences: 'Because your previous institution or degree program has not yet been reviewed by our university, no courses are shown on this list.',
  Detail: 'What does this mean?',
  AcademicReview: 'Your completed courses will be manually evaluated by our academic team.',
  ConditionalEquivalence: 'We will grant you credit for courses based on equivalency, provided the content of your programs matches the minimum content requirements of the courses you will be studying at Siglo 21.',
  PossibleEquivalences: 'Please note that this simulation shows a baseline scenario. You may be awarded additional credits once we evaluate the course content of your previously passed courses at your home institution. If the content of your courses matches the minimum requirements for the courses you will be studying at Siglo, we will grant you credit for those courses by equivalency.',
  CompleteInformation: 'Complete your basic information',
  PersonalContactsDetails: 'Enter your personal and contact details',
  SimulatedEquivalencies: 'Simulate your course equivalencies',
  AccessSimulator: 'Access the simulator and find out which courses may be recognized based on your home institution',
  StartProcess: 'Start your course equivalency process',
  UploadDocuments: 'Upload your documents and track the status of your application online',
  suggestedCareers: 'Show suggested careers',
  documentUploaded: 'Data obtained correctly from the academic system',
  academicDocumentation: 'Academic documentation',
  personalDocumentation: 'Personal documentation',
}
